var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-set-date",
      attrs: {
        title: "指定发货日期",
        visible: _vm.visibleDialog,
        width: "440px",
        top: "calc(50vh - 130px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "date-con" },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              "如设定后，销售订单状态在发货中（待备货）被物流审核后则不能修改。"
            ),
          ]),
          _c("div", { staticClass: "lable" }, [_vm._v("发货日期")]),
          _c("el-date-picker", {
            staticClass: "data-picker",
            attrs: {
              type: "date",
              placeholder: "选择日期",
              formart: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              size: "mini",
              "picker-options": _vm.pickerOptions,
            },
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }